import { useState } from 'react'

import ConfirmationDialog from './ConfirmDialog/ConfirmationDialog'

export { ConfirmationDialog }

interface IDialogProps {
  onClose?: () => void
  onOpen?: () => void
}

export const useDialog = (props?: IDialogProps) => {
  const [isOpen, setOpen] = useState(false)

  const open = () => setOpen(true)
  const close = () => setOpen(false)

  const handleOpen = () => {
    open()
    props?.onOpen?.()
  }
  const handleClose = () => {
    props?.onClose?.()
    close()
  }

  return { isOpen, open, close, handleOpen, handleClose }
}
